export const TOPIC_NAMES = {
  CLOSE_COPILOT: 'CLOSE_COPILOT',
  COLLABORATE_COPILOT_ACTON: 'COLLABORATE_COPILOT_ACTON',
  COLLABORATE_COPILOT_GET_CONTEXT: 'COLLABORATE_COPILOT_GET_CONTEXT',
  COLLABORATE_COPILOT_SET_CONTEXT: 'COLLABORATE_COPILOT_SET_CONTEXT',
  COLLABORATE_PARENT_APP_MESSAGE: 'COLLABORATE_PARENT_APP_MESSAGE',
  COPY_LAST_RESPONSE: 'COPY_LAST_RESPONSE',
  EXPAND_COLLAPSE: 'EXPAND_COLLAPSE',
  FOCUS_INPUT: 'FOCUS_INPUT',
  LAUNCH_FROM_COPILOT_PREVIEW: 'LAUNCH_FROM_COPILOT_PREVIEW',
  LAUNCH_WITH_CUSTOM_COPILOT: 'LAUNCH_WITH_CUSTOM_COPILOT',
  OPEN_PROMPT_TEMPLATE: 'OPEN_PROMPT_TEMPLATE',
  OPEN_ACTION_FORM: 'OPEN_ACTION_FORM',
  OPEN_COPILOT: 'OPEN_COPILOT',
  OPEN_THREAD: 'OPEN_THREAD',
  OPEN_CONVERSATION: 'OPEN_CONVERSATION',
  PROMPT_USER_FOR_MORE_INFO: 'PROMPT_USER_FOR_MORE_INFO',
  SEND_ACTION: 'SEND_ACTION',
  SEND_BREEZE_ACTION: 'SEND_BREEZE_ACTION',
  SEND_MESSAGE: 'SEND_MESSAGE',
  START_NEW_CHAT: 'START_NEW_CHAT',
  COMPOSABLE_UI_ACTION_CLICKED: 'COMPOSABLE_UI_ACTION_CLICKED',
  ADD_STARTER_ACTIONS: 'ADD_STARTER_ACTIONS',
  OPEN_BREEZE_EMAIL_SUPPORT_MODAL: 'OPEN_BREEZE_EMAIL_SUPPORT_MODAL',
  OPEN_BREEZE_IMAGE_LIGHTBOX_MODAL: 'OPEN_BREEZE_IMAGE_LIGHTBOX_MODAL',
  OPEN_BREEZE_CHAT_SUPPORT_MODAL: 'OPEN_BREEZE_CHAT_SUPPORT_MODAL',
  OPEN_BREEZE_PROJECTS_MODAL: 'OPEN_BREEZE_PROJECTS_MODAL',
  SUBMIT_BREEZE_EMAIL_SUPPORT: 'SUBMIT_BREEZE_EMAIL_SUPPORT',
  SUBMIT_BREEZE_CHAT_SUPPORT: 'SUBMIT_BREEZE_CHAT_SUPPORT',
  INSERT_EMAIL_DRAFT: 'INSERT_EMAIL_DRAFT',
  SET_BREEZE_CONTEXT: 'SET_BREEZE_CONTEXT',
  SEND_BREEZE_MESSAGE: 'SEND_BREEZE_MESSAGE',
  INVOKE_BREEZE_SKILL: 'INVOKE_BREEZE_SKILL',
  CLEAR_ATTACHED_CONTEXT: 'CLEAR_ATTACHED_CONTEXT'
};

/** BZE-native payload for setting persistent per-message context. */

/** BZE-native payload for sending a message to the Breeze assistant. */

/** BZE-native payload for invoking a specific skill with a message. */